<template>
  <div v-if="soma && soma.valor_total > 0" class="q-mt-md" :style="pendente ? 'opacity: 0.5' : ''">
    <p class="q-mb-xs text-weight-bold">Cédulas das sangrias selecionadas</p>

    <q-markup-table v-if="notas.length > 0" flat dense separator="horizontal">
      <tbody>
        <tr v-for="nota in notas" :key="nota.campo">
          <td class="text-left">R$ {{ $currency(nota.face) }}</td>
          <td class="text-right">{{ nota.quantidade }}</td>
          <td class="text-right">R$ {{ $currency(nota.quantidade * nota.face) }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="text-weight-bold">
          <td class="text-left">Total</td>
          <td class="text-right">{{ soma.quantidade_notas }}</td>
          <td class="text-right">R$ {{ $currency(soma.valor_notas) }}</td>
        </tr>
      </tfoot>
    </q-markup-table>

    <q-banner v-if="soma.sem_detalhamento.length > 0" dense class="bg-orange-1 q-mt-sm">
      <template v-slot:avatar>
        <q-icon color="orange" name="warning" />
      </template>
      <span v-if="notas.length === 0">
        Nenhuma das sangrias selecionadas tem detalhamento de notas. A transferência será salva sem
        contagem de cédulas.
      </span>
      <span v-else>
        R$ {{ $currency(soma.valor_detalhado) }} de R$ {{ $currency(soma.valor_total) }} têm
        detalhamento de notas; {{ soma.sem_detalhamento.length }}
        {{ soma.sem_detalhamento.length === 1 ? "sangria" : "sangrias" }} sem detalhamento. A contagem
        gravada fica parcial e pode ser completada no detalhamento de notas da transferência, no extrato.
      </span>
    </q-banner>

    <q-banner v-if="notas.length > 0 && divergente" dense class="bg-orange-1 q-mt-sm">
      <template v-slot:avatar>
        <q-icon color="orange" name="warning" />
      </template>
      <span v-if="soma.valor_moedas > 0">
        As cédulas (R$ {{ $currency(soma.valor_notas) }}) e moedas (R$ {{ $currency(soma.valor_moedas) }})
        contadas somam R$ {{ $currency(soma.valor_notas + soma.valor_moedas) }}, mas as sangrias detalhadas
        somam R$ {{ $currency(soma.valor_detalhado) }}.
      </span>
      <span v-else>
        As cédulas contadas somam R$ {{ $currency(soma.valor_notas) }}, mas as sangrias detalhadas somam
        R$ {{ $currency(soma.valor_detalhado) }}.
      </span>
    </q-banner>
  </div>
</template>

<script>
import axios from "@/axios-auth";
import { debounce } from "quasar";

const NOTAS = [
  { campo: "notas_2", face: 2 },
  { campo: "notas_5", face: 5 },
  { campo: "notas_10", face: 10 },
  { campo: "notas_20", face: 20 },
  { campo: "notas_50", face: 50 },
  { campo: "notas_100", face: 100 },
  { campo: "notas_200", face: 200 },
];

/**
 * Soma das cédulas contadas nas sangrias marcadas para compor a transferência. A soma vem do back
 * (POST /financeiro/sangrias-notas), que faz a mesma conta ao salvar e grava o resultado como
 * contagem de notas da transferência.
 */
export default {
  name: "cedulas-sangrias",
  props: {
    sangriasId: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      soma: null,
      pendente: false,
    };
  },
  computed: {
    consulta() {
      return this.sangriasId.join(",");
    },
    notas() {
      if (!this.soma) return [];

      return NOTAS
        .map(nota => ({ ...nota, quantidade: this.soma.notas[nota.campo] || 0 }))
        .filter(nota => nota.quantidade > 0);
    },
    // No caixa, a sangria detalhada vale cédulas + moedas; só as cédulas vão para a transferência.
    divergente() {
      const contado = this.soma.valor_notas + (this.soma.valor_moedas || 0);
      return Math.round(contado * 100) !== Math.round(this.soma.valor_detalhado * 100);
    },
  },
  watch: {
    consulta() {
      // Descarta já a resposta em voo: ela é da seleção anterior.
      this.pedidos++;
      this.pendente = true;
      this.consultarComAtraso();
    },
  },
  created() {
    this.pedidos = 0;
    this.consultarComAtraso = debounce(this.consultar, 400);
  },
  mounted() {
    this.consultar();
  },
  beforeUnmount() {
    this.consultarComAtraso.cancel();
    this.pedidos++;
  },
  methods: {
    async consultar() {
      const pedido = ++this.pedidos;

      if (this.sangriasId.length === 0) {
        this.soma = null;
        this.pendente = false;
        return;
      }

      const res = await axios.post("/financeiro/sangrias-notas", { ids: this.sangriasId });

      // Marcando várias sangrias seguidas, uma resposta antiga pode chegar depois da nova.
      if (pedido !== this.pedidos) {
        return;
      }

      // Sem a soma a tela segue como antes; quem grava a contagem é o back ao salvar.
      this.soma = res.error || !res.data || !res.data.success ? null : res.data.data;
      this.pendente = false;
    },
  },
};
</script>
